














import { Component, Mixins } from 'vue-property-decorator'
import ModalBase from '@/components/common/molecules/ModalBase.vue'
import ModalBaseMethod from '@/mixins/ModalBaseMethod.vue'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import MarkerListApis from '@/mixins/requests/admin/MarkerListApis.vue'
import { SelectOption } from '@/components/common/atoms/SelectBase.vue'

@Component({
  components: {
    ModalBase,
    ButtonBase,
    InputSimple,
  },
})
export default class ModalSubjectUpdate extends Mixins(ModalBaseMethod, MarkerListApis) {
  private errorMessage = ''
  private subjectList: SelectOption[] = []
  private subjectCodes: string[] = []

  init() {
    this.errorMessage = ''
    this.subjectCodes = []
  }

  setErrorMessage(message: string): void {
    this.errorMessage = message
  }

  public showModal(subjectOptions: SelectOption[]) {
    this.init()
    this.subjectList = subjectOptions
    this.show()
  }

  private async onClickOk(): Promise<void> {
    if (this.validateSubject()) {
      this.hide()
      this.$emit('click-ok', this.subjectCodes)
    }
  }

  /**
   * 教科バリデーション
   */
  private validateSubject(): boolean {
    if (this.subjectCodes.length == 0) {
      this.errorMessage = '教科が未設定です'
      return false
    }

    return true
  }

  /**
   * id生成
   */
  private get getId(): string {
    return `id${this.$uuid.v4()}`
  }

  /**
   * id取得
   */
  private getIdWithIndex(index: number): string {
    return `${this.getId}_${index}`
  }
}
